export function Footer() {
  return (
    <footer className="border-t border-beige/20 py-6 mt-auto">
      <div className="max-w-5xl mx-auto px-4 text-center text-sm text-grey font-body">
        <p>Powered by x402 &middot; Pay-per-article publishing</p>
      </div>
    </footer>
  );
}
